module.exports = __webpack_public_path__ + "static/media/logo-big@2x.1a07e595.png";